/* global __DEVTOOLS__ */
import { createStore, applyMiddleware, compose } from "redux";
// reducer
import rootReducer from "../reducers";
// middleware
import thunkMiddleware from "redux-thunk";
import promiseMiddleware from "redux-promise";
import { createLogger } from "redux-logger";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
const enforceImmutableMiddleware = reduxImmutableStateInvariant({
  ignore: [
    "modalDialog",
    "form", // Ignore stores with file upload
  ],
});
const loggerMiddleware = createLogger({
  level: "info",
  collapsed: true,
  predicate: (getState, action) => action.type !== "EVENT_SOURCE_RECEIVE",
});
let createStoreWithMiddleware;

/**
 * Konfigurace store včetně middlewares.
 */
// @ts-ignore
if (typeof __DEV__ !== "undefined" && __DEV__) {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  createStoreWithMiddleware = composeEnhancers(
    applyMiddleware(enforceImmutableMiddleware, thunkMiddleware, promiseMiddleware, loggerMiddleware)
  )(createStore);
} else {
  createStoreWithMiddleware = compose(applyMiddleware(thunkMiddleware, promiseMiddleware))(createStore);
}
/**
 * Creates a preconfigured store.
 */

export default function configureStore(initialState) {
  const store = createStoreWithMiddleware(rootReducer, initialState);

  // @ts-ignore
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    // @ts-ignore
    module.hot.accept("../reducers/index", () => {
      const nextRootReducer = require("../reducers").default;

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
